import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './images/KrossKast_Logo-red.png';
import backgroundImage from './images/sign-up-desk-background-image.jpg';
import './App.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically make an API call to send the reset email
    setIsSubmitted(true);
  };

  return (
    <div
      className="signin-page"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
      }}
    >
      <div className="top-nav" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <img src={logo} alt="KrossKast" className="nav-logo" />
        <div className="user-nav">
          <button 
            className="signin-button"
            onClick={() => navigate('/signin')}
          >
            Sign In
          </button>
        </div>
      </div>
      <div className="signin-container">
        <div className="signin-form-container" style={{ maxWidth: 400 }}>
          {!isSubmitted ? (
            <>
              <h1 style={{ fontSize: '22px' }}>Reset Your Password</h1>
              <p style={{ fontSize: '14px', marginTop: '-1px', color: '#000000', marginBottom: '24px' }}>
                Enter your email address and we'll send you instructions to reset your password.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label style={{ fontSize: '14px' }}>Email<span className="required">*</span></label>
                  <input 
                    type="email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{ fontSize: '14px' }}
                    required 
                  />
                </div>
                <button type="submit" className="continue-btn" style={{ marginTop: '24px' }}>
                  Send Reset Instructions
                </button>
                <div style={{ textAlign: 'center', marginTop: '16px' }}>
                  <button 
                    type="button" 
                    onClick={() => navigate('/signin')}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#000000',
                      fontSize: '14px',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      padding: '0'
                    }}
                  >
                    Back to Sign In
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <h1 style={{ fontSize: '22px', marginBottom: '16px' }}>Check Your Email</h1>
              <p style={{ fontSize: '14px', color: '#000000' }}>
                We've sent password reset instructions to <strong>{email}</strong>.
              </p>
              <p style={{ fontSize: '14px', color: '#000000', marginTop: '8px' }}>
                If you don't see the email, please check your spam folder.
              </p>
              <button 
                onClick={() => navigate('/signin')}
                className="continue-btn"
                style={{ marginTop: '24px' }}
              >
                Return to Sign In
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 